import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_AdvisorNewContent = new ThunderDispatcher('__onNewAdvisorContent');
export const dispatch_onHPIGiven = new ThunderDispatcher('__onHPIGiven');
export const dispatch_OnPathwayEndUpdated = new ThunderDispatcher('__onPathwayEndUpdated');
export const dispatch_ExpandProtocolInfo = new ThunderDispatcher('__onExpandProtocolInfo', true);
export const dispatch_ScrollTo = new ThunderDispatcher('__onScrollTo');
export const dispatch_FocusedEntitiesUpdated = new ThunderDispatcher('__onFocusedEntitiesUpdated');
//# sourceMappingURL=general.js.map